<span class="c-nome-lista">
  {{obterDadosPaginacao(dados)}} {{nomeDaLista}}
</span>
<ngb-pagination [collectionSize]="dados.totalDeItens" [pageSize]="dados.itensPorPagina" [(page)]="dados.paginaAtual"
  [maxSize]="5" [rotate]="true" (pageChange)="dadosChange.emit(dados)"></ngb-pagination>
<select class="form-select u-width-auto" [(ngModel)]="dados.itensPorPagina" (ngModelChange)="manipularItensPorPagina()">
  <ng-container *ngFor="let itemPorPagina of itensPorPagina">
    <option [ngValue]="itemPorPagina">{{itemPorPagina}} itens por página</option>
  </ng-container>
</select>
